

{
  "familyId": "GET-NEGATIEF",
  "questions": [
    {
      "id": "GET-NEGATIEF-001",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Welk getal is kleiner: -5 of -2?",
      "context": null,
      "options": ["-5", "-2", "ze zijn even groot", "dat kun je niet zeggen zonder verdere informatie"],
      "correctAnswer": 0,
      "conceptId": "negative_compare_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-grootte-omgekeerd", "label": "Grotere absolute waarde = groter getal", "optionIndex": 1 },
          { "id": "get.negatief-gelijk-aangenomen", "label": "Twee verschillende getallen als even groot beoordeeld", "optionIndex": 2 },
          { "id": "get.negatief-onbeslist", "label": "Vergelijking als onbepaald beschouwd", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [0],
            "label": "Getallenlijn — gebruik nul als anker",
            "start": -10,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": -5,
            "minTemp": -10,
            "maxTemp": 5,
            "targetTemp": -2,
            "unit": "C",
            "label": "Thermometer: -5 °C ligt lager (kouder) dan -2 °C, dus -5 is kleiner"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatieve getallen vergelijken",
            "content": "Bij negatieve getallen: hoe groter het getal achter het minteken, hoe kleiner het getal. Op de getallenlijn of thermometer: hoe verder naar links/onderen, hoe kleiner. Dus -5 < -2 (vijf graden vorst is kouder dan twee graden vorst).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Vergelijk -5 en -2 met behulp van de getallenlijn of een thermometer. -5 ligt verder naar links (of dieper onder nul). Hoe verder naar links, hoe kleiner het getal. Dus -5 < -2. Denk aan temperaturen: -5 °C is kouder dan -2 °C, en kouder = kleiner getal.",
        "solutionSteps": [
          "Stel je de getallenlijn voor met nul in het midden",
          "-5 staat 5 stapjes links van nul, -2 staat 2 stapjes links",
          "Hoe verder naar links, hoe kleiner",
          "Dus -5 < -2 → -5 is kleiner"
        ],
        "distractorExplanations": {
          "0": "Goed! -5 ligt verder onder nul dan -2, dus -5 is kleiner.",
          "1": "Je dacht waarschijnlijk: 5 > 2, dus -5 > -2. Maar bij negatieve getallen geldt het omgekeerde: hoe groter het getal achter het minteken, hoe kleiner het getal. Vergelijk met temperatuur: -5 °C is kouder dan -2 °C.",
          "2": "Je dacht waarschijnlijk dat -5 en -2 even groot zijn. Maar -5 en -2 zijn verschillende getallen op verschillende plekken op de getallenlijn. Twee verschillende getallen zijn nooit even groot.",
          "3": "Je kunt het wél zeggen. Gebruik de getallenlijn of denk aan temperatuur: -5 staat verder links / is kouder dan -2. Op de getallenlijn geldt altijd: links = kleiner."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-002",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -3 + 5 =",
      "context": null,
      "options": ["2", "-2", "8", "-8"],
      "correctAnswer": 0,
      "conceptId": "negative_add_positive",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-grootte-omgekeerd", "label": "Antwoord negatief gehouden", "optionIndex": 1 },
          { "id": "get.negatief-teken-genegeerd", "label": "Minteken genegeerd", "optionIndex": 2 },
          { "id": "get.negatief-fout-bewerking", "label": "Optellen verward met aftrekken", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-3, 0],
            "label": "Getallenlijn: start bij -3, anker bij 0",
            "start": -5,
            "end": 10
          }
        }
      ],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": -3,
            "minTemp": -10,
            "maxTemp": 10,
            "targetTemp": 2,
            "unit": "C",
            "label": "Van -3 °C met 5 graden omhoog → 2 °C"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatief getal + positief getal",
            "content": "Beeld het in als temperatuur die stijgt: begin bij -3 °C en ga 5 graden omhoog. Je passeert 0 °C en komt uit op +2 °C. Optellen = naar rechts / omhoog op de schaal.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Begin bij -3 op de getallenlijn (of thermometer). Optellen = naar rechts/omhoog. Ga 5 stappen omhoog: -3 → -2 → -1 → 0 → 1 → 2. Je passeert nul en komt uit op +2.",
        "solutionSteps": [
          "Begin bij -3",
          "Optellen = naar rechts/omhoog",
          "5 stappen omhoog: -3 → -2 → -1 → 0 → 1 → 2",
          "Je passeert nul en komt uit op +2"
        ],
        "distractorExplanations": {
          "0": "Goed! Begin bij -3, ga 5 stappen omhoog: -3 + 5 = 2.",
          "1": "Je dacht waarschijnlijk dat het antwoord negatief blijft. Maar begin bij -3 en ga 5 stappen omhoog — je passeert nul en komt uit op +2 (positief). Onthoud: zodra je voorbij nul gaat, wordt het antwoord positief.",
          "2": "Je dacht waarschijnlijk dat -3 + 5 = 8 (alsof er +3 + 5 stond). Maar het minteken hoort bij de 3: je begint dus bij -3, niet bij 3. Antwoord: -3 + 5 = 2.",
          "3": "Je hebt waarschijnlijk + verward met − en -3 + (-5) = -8 berekend. Maar er staat +5, dus je telt 5 op (omhoog): -3 + 5 = 2."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-003",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: 4 - 7 =",
      "context": null,
      "options": ["-3", "3", "11", "-11"],
      "correctAnswer": 0,
      "conceptId": "negative_result_subtraction",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-volgorde-omgedraaid", "label": "4-7 verward met 7-4", "optionIndex": 1 },
          { "id": "get.negatief-fout-bewerking", "label": "Aftrekken verward met optellen", "optionIndex": 2 },
          { "id": "get.negatief-teken-toegevoegd", "label": "Onnodig minteken toegevoegd", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": 4,
            "minTemp": -10,
            "maxTemp": 10,
            "targetTemp": -3,
            "unit": "C",
            "label": "Van 4 °C met 7 graden omlaag → -3 °C"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken voorbij nul",
            "content": "Beeld het in als afkoeling: 4 °C en het wordt 7 graden kouder. Eerst 4 graden naar 0, dan nog 3 graden naar -3. Aftrekken = naar links / omlaag.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Begin bij 4 op de getallenlijn. Aftrekken = naar links/omlaag. Ga 7 stappen: 4 → 3 → 2 → 1 → 0 → -1 → -2 → -3. Je passeert nul en komt in het negatieve gebied: 4 - 7 = -3.",
        "solutionSteps": [
          "Begin bij 4",
          "Aftrekken = naar links/omlaag",
          "7 stappen: 4 → 3 → 2 → 1 → 0 → -1 → -2 → -3",
          "Je passeert nul, antwoord: -3"
        ],
        "distractorExplanations": {
          "0": "Goed! Begin bij 4, ga 7 stappen omlaag, je passeert nul: 4 - 7 = -3.",
          "1": "Je dacht waarschijnlijk dat 4 - 7 hetzelfde is als 7 - 4 = 3. Maar bij aftrekken mag je de volgorde NIET omdraaien: 4 - 7 ≠ 7 - 4. Begin bij 4 en ga 7 omlaag: -3.",
          "2": "Je dacht waarschijnlijk dat er + stond i.p.v. -: 4 + 7 = 11. Maar er staat een minteken: je trekt 7 af, je telt niet op. Antwoord: -3.",
          "3": "Je hebt waarschijnlijk eerst 4 + 7 = 11 gedaan en daarna een minteken toegevoegd. Maar 4 - 7 is niet hetzelfde als -(4+7). Begin bij 4 en trek 7 af: 4 - 7 = -3."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-004",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -3 × 4 =",
      "context": null,
      "options": ["-12", "12", "-7", "7"],
      "correctAnswer": 0,
      "conceptId": "negative_multiply_positive",
      "variantIndex": 4,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-teken-genegeerd", "label": "Minteken vergeten in antwoord", "optionIndex": 1 },
          { "id": "get.negatief-fout-bewerking", "label": "Vermenigvuldigen verward met optellen", "optionIndex": 2 },
          { "id": "get.negatief-teken-genegeerd", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-3, 0],
            "label": "Getallenlijn: start bij -3, anker bij 0",
            "start": -15,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-12, -9, -6, -3, 0],
            "highlight": [-12],
            "arrows": [
              { "from": 0, "to": -3, "label": "1× -3" },
              { "from": -3, "to": -6, "label": "2× -3" },
              { "from": -6, "to": -9, "label": "3× -3" },
              { "from": -9, "to": -12, "label": "4× -3 = -12" }
            ],
            "label": "Regel: negatief × positief = negatief. 4 keer -3 = -12",
            "start": -15,
            "end": 5
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tekenregel bij vermenigvuldigen",
            "content": "Bereken eerst zonder teken: 3 × 4 = 12. Bepaal dan het teken: negatief × positief = negatief. Onthoud: één minteken in een vermenigvuldiging → antwoord is negatief.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 3 × 4 = 12. Bepaal dan het teken: negatief × positief = negatief. Dus -3 × 4 = -12.",
        "solutionSteps": [
          "Bereken zonder teken: 3 × 4 = 12",
          "Bepaal het teken: negatief × positief = negatief",
          "Dus -3 × 4 = -12"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 4 = 12, en negatief × positief = negatief, dus -3 × 4 = -12.",
          "1": "Je dacht waarschijnlijk dat het antwoord positief is. Maar 3 × 4 = 12 klopt, en -3 × 4 geeft een negatief antwoord: negatief × positief = negatief. Onthoud: één minteken in een vermenigvuldiging geeft een negatief antwoord.",
          "2": "Je dacht waarschijnlijk dat je -3 + (-4) = -7 moest berekenen. Maar er staat een × (vermenigvuldiging). Bereken: 3 × 4 = 12, en negatief × positief = negatief, dus -12. Onthoud: × is vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat het antwoord 7 is, alsof je 3+4=7 zou doen. Maar er staat een × (vermenigvuldiging): 3 × 4 = 12, en negatief × positief = negatief, dus -3 × 4 = -12. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-005",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -2 × -5 =",
      "context": null,
      "options": ["10", "-10", "7", "-7"],
      "correctAnswer": 0,
      "conceptId": "negative_multiply_negative",
      "variantIndex": 5,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.8,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-tekenregel-vergeten", "label": "Twee mintekens niet opgeheven", "optionIndex": 1 },
          { "id": "get.negatief-fout-bewerking", "label": "Vermenigvuldigen verward met optellen", "optionIndex": 2 },
          { "id": "get.negatief-fout-bewerking", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-5, 0],
            "label": "Getallenlijn: ankers bij -5 en 0",
            "start": -5,
            "end": 15
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [0, 10],
            "highlight": [10],
            "label": "Regel: negatief × negatief = positief. -2 × -5 = +10",
            "start": -5,
            "end": 15
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee mintekens heffen elkaar op",
            "content": "Bereken eerst zonder teken: 2 × 5 = 10. Bepaal dan het teken: negatief × negatief = positief. Twee mintekens samen vormen een plusteken.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 2 × 5 = 10. Bepaal dan het teken: negatief × negatief = positief (twee mintekens heffen elkaar op). Dus -2 × -5 = +10.",
        "solutionSteps": [
          "Bereken zonder teken: 2 × 5 = 10",
          "Bepaal het teken: negatief × negatief = positief",
          "Twee mintekens heffen elkaar op",
          "Dus -2 × -5 = +10"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × 5 = 10, en negatief × negatief = positief, dus -2 × -5 = +10.",
          "1": "Je dacht waarschijnlijk dat negatief × negatief negatief geeft. Maar twee mintekens heffen elkaar op: negatief × negatief = positief. Onthoud: twee mintekens samen = plusteken.",
          "2": "Je dacht waarschijnlijk dat je -2 + 5 moest berekenen. Maar er staat een × (vermenigvuldiging): 2 × 5 = 10, en negatief × negatief = positief, dus +10. Onthoud: × is vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je -2 + (-5) = -7 moest berekenen. Maar er staat een × (vermenigvuldiging): 2 × 5 = 10, en negatief × negatief = positief, dus +10. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-006",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -20 ÷ 4 =",
      "context": null,
      "options": ["-5", "5", "-16", "16"],
      "correctAnswer": 0,
      "conceptId": "negative_divide_positive",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.negatief-teken-genegeerd", "label": "Minteken vergeten in antwoord", "optionIndex": 1 },
          { "id": "get.negatief-fout-bewerking", "label": "Delen verward met aftrekken", "optionIndex": 2 },
          { "id": "get.negatief-fout-bewerking", "label": "Optellen i.p.v. delen", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-20, 0],
            "label": "Getallenlijn: start bij -20, anker bij 0",
            "start": -25,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-20, -15, -10, -5, 0],
            "highlight": [-5],
            "arrows": [
              { "from": -20, "to": -5, "label": "-20 in 4 gelijke delen = -5 per deel" }
            ],
            "label": "Regel: negatief ÷ positief = negatief. -20 ÷ 4 = -5",
            "start": -25,
            "end": 5
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tekenregel bij delen",
            "content": "Bereken eerst zonder teken: 20 ÷ 4 = 5. Bepaal dan het teken: negatief ÷ positief = negatief. Dus -20 ÷ 4 = -5.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 20 ÷ 4 = 5. Bepaal dan het teken: negatief ÷ positief = negatief. Dus -20 ÷ 4 = -5.",
        "solutionSteps": [
          "Bereken zonder teken: 20 ÷ 4 = 5",
          "Bepaal het teken: negatief ÷ positief = negatief",
          "Dus -20 ÷ 4 = -5"
        ],
        "distractorExplanations": {
          "0": "Goed! 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -20 ÷ 4 = -5.",
          "1": "Je dacht waarschijnlijk dat het antwoord positief is. Maar 20 ÷ 4 = 5 klopt, en -20 ÷ 4 geeft een negatief antwoord: negatief ÷ positief = negatief. Onthoud: één minteken bij delen geeft een negatief antwoord.",
          "2": "Je dacht waarschijnlijk dat je -20 + 4 = -16 moest berekenen. Maar er staat een ÷ (delen): 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -5. Onthoud: ÷ is delen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je -20 + 4 = -16 berekende en dan het teken omdraaide. Maar er staat een ÷ (delen): 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -20 ÷ 4 = -5. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-007",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "thermometer_slider",
      "question": "De temperatuur in een vriezer is −4 °C. Hij stijgt met 7 graden. Zet de thermometer op de juiste eindtemperatuur.",
      "context": null,
      "options": [],
      "correctAnswer": 3,
      "data": {
        "minTemp": -15,
        "maxTemp": 15,
        "step": 1,
        "unit": "°C",
        "startTemp": -4,
        "promptLabel": "Eindtemperatuur na +7 graden"
      },
      "conceptId": "negative_thermometer_add",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "thermometer",
          "data": {
            "currentTemp": -4,
            "minTemp": -15,
            "maxTemp": 15,
            "unit": "C",
            "label": "Starttemperatuur: −4 °C"
          }
        }
      ],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": 3,
            "minTemp": -15,
            "maxTemp": 15,
            "targetTemp": -4,
            "unit": "C",
            "label": "Van −4 °C met 7 graden omhoog → 3 °C"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatief getal + positief — de thermometer omhoog",
            "content": "Stijgen op de thermometer = optellen. Begin bij −4, ga 7 graden omhoog: eerst 4 graden naar 0, dan nog 3 graden naar +3. Dus −4 + 7 = 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Begin bij −4 °C op de thermometer. Stijgen = optellen, dus ga 7 graden omhoog: −4 → −3 → −2 → −1 → 0 → 1 → 2 → 3. Je passeert nul en komt uit op +3 °C.",
        "solutionSteps": [
          "Start op de thermometer: −4 °C",
          "Stijgen = optellen, dus ga 7 graden omhoog",
          "Eerst 4 graden naar 0, dan 3 graden verder",
          "Eindtemperatuur: +3 °C"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "GET-NEGATIEF-008",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "ordering",
      "question": "Zet deze temperaturen op volgorde van koudst naar warmst:",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["−2 °C", "5 °C", "−7 °C", "0 °C", "−10 °C"],
        "correctOrder": [4, 2, 0, 3, 1]
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-10, -7, -2, 0, 5],
            "label": "Getallenlijn: van koudst naar warmst",
            "start": -15,
            "end": 10
          }
        }
      ],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": -10,
            "minTemp": -15,
            "maxTemp": 10,
            "targetTemp": 5,
            "unit": "C",
            "label": "Van koudst (−10 °C) onderaan tot warmst (5 °C) bovenaan"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatieve getallen ordenen",
            "content": "Bij negatieve getallen: hoe groter het getal achter het minteken, hoe kleiner (kouder). −10 < −7 < −2 < 0 < 5. Gebruik de getallenlijn of thermometer als hulp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negative_ordering",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Bij negatieve getallen geldt: hoe groter het getal achter het minteken, hoe kleiner (kouder). Volgorde van koudst naar warmst: −10 °C < −7 °C < −2 °C < 0 °C < 5 °C.",
        "solutionSteps": [
          "Zet alle temperaturen op de getallenlijn of thermometer",
          "Hoe verder naar links/onderen, hoe kouder",
          "Koudst: −10 °C (verst onder nul)",
          "Warmst: 5 °C (verst boven nul)",
          "Volgorde: −10 < −7 < −2 < 0 < 5"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-NEGATIEF-009",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "comparison_judge",
      "question": "Welke temperatuur is het koudst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "−6 °C", "label": "min zes graden" },
            { "id": "b", "content": "−9 °C", "label": "min negen graden" },
            { "id": "c", "content": "−4 °C", "label": "min vier graden" }
          ],
          "criterion": "het koudst",
          "correctIndex": 1
        }
      },
      "options": [],
      "correctAnswer": 0,
      "conceptId": "negative_judge_coldest",
      "variantIndex": 9,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "currentTemp": -9,
            "minTemp": -15,
            "maxTemp": 5,
            "unit": "C",
            "label": "−9 °C is het verst onder nul → het koudst"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijken van negatieve temperaturen",
            "content": "Hoe groter het getal achter het minteken, hoe kouder. Vergelijk: −9 < −6 < −4. Het koudst = de laagste temperatuur = −9 °C.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Vergelijk de drie temperaturen: −6, −9 en −4. Bij negatieve getallen: hoe groter het getal achter het minteken, hoe kouder (kleiner). Volgorde van koudst naar warmst: −9 °C < −6 °C < −4 °C. Dus −9 °C is het koudst.",
        "solutionSteps": [
          "Lees de drie temperaturen: −6, −9, −4",
          "Negeer even het minteken: 9 > 6 > 4",
          "Bij negatief geldt het omgekeerde: −9 < −6 < −4",
          "Koudst = laagste temperatuur = −9 °C"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}

